import { useI18n } from 'vue-i18n';

const KNOWN_ERROR_CODES = new Set([
  '100',
  '368',
  '470',
  '21610',
  '21617',
  '30008',
  '63003',
  '63005',
  '63016',
  '63018',
  '63024',
  '63032',
  '63038',
  '63049',
  '63051',
  '63112',
  '131000',
  '131026',
  '131031',
  '131042',
  '131045',
  '131047',
  '131049',
  '131051',
  '131053',
  '132000',
  '132001',
  '132005',
  '132007',
  '132012',
  '133010',
]);

const INTERNAL_ERROR_KEYS = {
  'Template name could not be resolved': 'TEMPLATE_NAME',
  'Template not found': 'TEMPLATE_NOT_FOUND',
  'No message id returned by the provider': 'NO_MESSAGE_ID',
  'Failed to create message': 'MESSAGE_CREATE_FAILED',
  'Direct WhatsApp template send failed': 'TEMPLATE_SEND_FAILED',
};

const ERROR_CODE_PATTERNS = [
  // Twilio REST errors start with an HTTP status before the provider code.
  /^\s*\[HTTP\s+\d{3}\]\s+(\d+)\s*:/i,
  /^\s*(\d+)\s*(?::|-|$)/,
  /^\s*\(#(\d+)\)/,
  /(?:error code|c[oó]digo de erro)\s*:\s*(\d+)/i,
];

const extractErrorCode = raw => {
  return ERROR_CODE_PATTERNS.reduce((code, pattern) => {
    return code || raw.match(pattern)?.[1];
  }, undefined);
};

const hasErrorDetails = (raw, code) => {
  const detail = raw
    .replace(/^\s*\[HTTP\s+\d{3}\]\s+\d+\s*:\s*/i, '')
    .replace(/^\s*\d+\s*$/, '')
    .replace(/^\s*\d+\s*[-:]\s*/, '')
    .replace(/^\s*\(#\d+\)\s*/, '')
    .replace(/^\s*(?:error code|c[oó]digo de erro)\s*:\s*\d+\s*\.?\s*/i, '')
    .trim();

  return Boolean(code && detail);
};

export const useWhatsappErrorTranslation = () => {
  const { t } = useI18n();

  const translateError = (raw, { preserveUnknownDetails = false } = {}) => {
    if (!raw) return '—';

    const error = String(raw);
    const code = extractErrorCode(error);
    if (code) {
      if (KNOWN_ERROR_CODES.has(code)) {
        return t(`WHATSAPP_ERRORS.CODE_${code}`);
      }

      return preserveUnknownDetails && hasErrorDetails(error, code)
        ? error
        : t('WHATSAPP_ERRORS.GENERIC', { code });
    }

    if (INTERNAL_ERROR_KEYS[error]) {
      return t(`WHATSAPP_ERRORS.${INTERNAL_ERROR_KEYS[error]}`);
    }

    return error;
  };

  return { translateError };
};
